/**
 * プッシュ通知登録
 */

import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Button,
    Grid,
    InputLabel,
    InputBase,
    FormControl,
    FormHelperText,
    MenuList,
    Paper,
    MenuItem,
    Select,
    DialogTitle,
} from '@material-ui/core';
import { dictionary } from 'mdoc/admin/axios'
import { getDepartmentSearch, getUserSearch } from 'mdoc/admin/axios/user'
import {
    pushDetail,
    pushLogin,
    pushUpdate
} from 'mdoc/admin/axios/push'
import { Link } from 'react-router-dom'
import { Close } from '@material-ui/icons';
import Dialog from 'mdoc/utils/myDialog';
import Toast from 'mdoc/utils/toast';
import * as config from 'mdoc/admin/axios/config'
import $ from 'jquery';
import { dateFormat } from 'mdoc/utils';
import { messageFormat, getLang } from 'mdoc/utils'
import schema from 'async-validator';
import { MuiPickersUtilsProvider, DateTimePicker } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import zhCNLocale from 'date-fns/locale/zh-CN';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import 'mdoc/admin/components/notify/notify.less';
import {
    Clear,
} from '@material-ui/icons';
const localeMap = {
    1: jaLocale,
    2: zhCNLocale,
    3: enLocale,
};
const lang = getLang();

const BootstrapInput = withStyles(theme => ({
    root: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        },
        width: '130px'
    },
    input: {
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 12,
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);
const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapFormLabel: {
        lineHeight: '30px',
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    },
    buttonlogin: {
        marginLeft: '380px',
        marginTop: '40px'
    },
    buttoncancel: {
        marginLeft: '30px',
        marginTop: '40px'
    },
    link: {
        textDecoration: 'none'
    },
    required: {
        color: '#F72D2D'
    },
    tags: {
        margin: theme.spacing.unit,
    },
    title: {
        marginLeft: '-20px'
    }
});

class PushNotify_Edit extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        loading: false,
        pagination: {
            page: 1,
            count: 0
        },
        dictWord: {
            'push_base_information': '',
            'push_notice_information': '',
            'all_user_publish': '',
            'notice_set': '',
            'department_specified': '',
            'user_appoint': '',
            'open_reservation': '',
            'registration': '',
            'cancel': '',
            'user_search': '',
            'department_search': '',
            'close': '',
            'name': '',
            'notified': '',
            'non_notification': '',
            'under_reservation': '',
            'msg_confirm_really_registration': '',
            'msg_error_not_null_with_item': '',
            'notice': '',
            'msg_warning_push_notice_information': '',
            'msg_error_over_length_with_item': '',
            'msg_error_record_exists': '',
            'department': '',
            'user_id': '',
            'department_designation': '',
            'user_name': '',
            'all_user_notice': '',
            'notice_reservation': '',
            'yes': '',
            'confirmation': '',
            'message': '',
            'msg_error_value_invalid':'',
            msg_error_not_enter_before_date: ''
        },
        formData: {
            DepartmentTags: {
                value: [],
                error: false,
                errorMsg: ''
            },
            UserTags: {
                value: [],
                error: false,
                errorMsg: ''
            },
            alertTimeStr: {
                value: null,//new Date(),
                error: false,
                errorMsg: ''
            },
            messageContent: {
                value: '',
                error: false,
                errorMsg: ''
            },
            alertStatus: {
                width: '',
                value: '',
                error: false,
                errorMsg: ''
            },
        },
        dialogOpenSearch: false,
        dialogOpenSearchUser: false,
        name: '',
        departmentName: '',
        department: [],
        user: [],
        alertStatus: config['PUSH_STATUS_DETAIL'],
        messageId: '',
        dialogOpen: false,
        okLoading: false
    }
    componentWillMount() {
        this.start(this.state);
    }
    componentDidMount() {
        let formData = this.state.formData;
        formData['alertStatus'] = Object.assign(this.state['formData']['alertStatus'], { width: $('#alertTimeStr').css('width') });
        this.setState({
            formData: formData
        });
    }
    start = (state) => {
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
        if (this.props.match.params.messageId !== undefined || this.props.location.state !== undefined) {
            let messageId = this.props.match.params.messageId;
            if (messageId === undefined) {
                messageId = this.props.location.state.messageId
            }
            this.setState({
                loading: true,
            });
            pushDetail(messageId).then(res => {
                const detail = res.results;
                let formData = this.state.formData;
                let messageContent = Object.assign(this.state['formData']['messageContent'], { value: detail['messageContent'] });
                formData['messageContent'] = messageContent;
                let dep = [];
                for (let key in detail['docMstDepartment']) {
                    let value = detail['docMstDepartment'][key];
                    dep.push({
                        id: value['id'],
                        departmentName: value['departmentName'],
                        // delFlag:value['delFlag']
                    });
                }
                let DepartmentTags = Object.assign(this.state['formData']['DepartmentTags'], { value: dep });
                formData['DepartmentTags'] = DepartmentTags;
                let user = [];
                for (let key in detail['docTblUser']) {
                    let value = detail['docTblUser'][key];
                    user.push({
                        id: value['id'],
                        name: value['name'],
                        // delFlag:value['delFlag']
                    });
                }
                let UserTags = Object.assign(this.state['formData']['UserTags'], { value: user });
                formData['UserTags'] = UserTags;
                let alert = detail['alertTimeStr'];
                if (alert === '') {
                    alert = null;
                } else {
                    alert = alert.replace(/\//g, '-');
                    alert = alert.replace(/\s+/g, 'T');
                }
                let alertTimeStr = Object.assign(this.state['formData']['alertTimeStr'], { value: alert });
                formData['alertTimeStr'] = alertTimeStr;
                let alertStatus = Object.assign(this.state['formData']['alertStatus'], { value: detail['alertStatus'] });
                formData['alertStatus'] = alertStatus;
                this.setState({
                    loading: false,
                    formData: formData
                });
            })
        }
    }
    checkLength = (count) => event => {
        let formData = this.state.formData;
        let value = { errorMsg: event.target.value.length + '/' + count, error: false };
        if (event.target.value.length <= count) {
            value['error'] = false;
        } else {
            value['error'] = true;
        }
        formData['messageContent'] = Object.assign(this.state['formData']['messageContent'], value);
        this.setState({
            formData: formData
        });
    }
    handleChange = (filed) => event => {
        let formData = this.state.formData;
        if (filed === 'alertTimeStr') {
            let value = event
            formData[filed] = Object.assign(this.state['formData'][filed], { value: value });
        } else {
            formData[filed] = Object.assign(this.state['formData'][filed], { value: event.target.value });
        }
        this.setState({
            formData: formData
        });
    };
    //department Tags
    handleDelTags = (tagid) => event => {
        let tags = this.state.formData.DepartmentTags.value;
        // tags[tagid]['delFlag']=1
        tags.splice(tagid, 1)
        let formData = this.state.formData;
        formData['DepartmentTags'] = Object.assign(this.state['formData']['DepartmentTags'], { value: tags });
        this.setState({
            formData: formData
        });
    }
    handleSearch = () => {
        this.setState({
            dialogOpenSearch: true,
            show: false,
            departmentName: '',
            department: []
        });
    }
    handleSearchValue = (departmentName, id) => (event) => {
        let formData = this.state.formData;
        let departmentTags = formData.DepartmentTags.value;
        let isSame = false;
        for (var key in formData['DepartmentTags']['value']) {
            let value = formData['DepartmentTags']['value'][key]
            // let del = value['delFlag']
            if (value['id'] === id) {
                isSame = true;
                break;
            }
        }
        if (isSame) {
            Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.department));
        } else {
            departmentTags.push({
                id: id,
                departmentName: departmentName,
                // delFlag:0
            });
            formData['DepartmentTags'] = Object.assign(this.state['formData']['DepartmentTags'], { value: departmentTags });
            this.setState({
                formData: formData,
                dialogOpenSearch: false
            });
        }
    }
    inputHandleSearch = (event) => {
        this.setState({
            departmentName: event.target.value
        },()=>{
            getDepartmentSearch({
                'departmentName': this.state.departmentName,
            }).then(res => {
                this.setState({
                    show: true
                })
                const department = res.results;
                let dep = [];
                for (var key in department) {
                    let value = department[key];
                    dep.push({
                        id: value['id'],
                        departmentName: value['departmentName'],
                    });
                }
                this.setState({
                    department: dep
                })
            }).catch(function (error) {
                Toast.error(error);
            })
        });
    }
    dialogHandleOff = () => {
        this.setState({
            dialogOpenSearch: false
        });
    }
    //user Tags
    handleDelUserTags = (tagid) => event => {
        let tags = this.state.formData.UserTags.value;
        // tags[tagid]['delFlag']=1
        tags.splice(tagid, 1)
        let formData = this.state.formData;
        formData['UserTags'] = Object.assign(this.state['formData']['UserTags'], { value: tags });
        this.setState({
            formData: formData
        });
    }
    handleSearchUser = () => {
        this.setState({
            dialogOpenSearchUser: true,
            show: false,
            name: '',
            user: []
        });
    }
    handleSearchUserValue = (name, id) => (event) => {
        let formData = this.state.formData;
        let userTags = formData.UserTags.value;
        let isUserSame = false;
        for (var key in formData['UserTags']['value']) {
            let value = formData['UserTags']['value'][key]
            if (value['id'] === id) {
                isUserSame = true;
                break;
            }
        }
        if (isUserSame) {
            Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.user_id));
        } else {
            userTags.push({
                id: id,
                name: name,
                // delFlag:0
            });
            formData['UserTags'] = Object.assign(this.state['formData']['UserTags'], { value: userTags });
            this.setState({
                formData: formData,
                dialogOpenSearchUser: false
            });
        }
    }
    inputHandleSearchUser = (event) => {
        this.setState({
            name: event.target.value
        },()=>{
            getUserSearch({
                'name': this.state.name,
            }).then(res => {
                this.setState({
                    show: true
                })
                const user = res.results;
                let userList = [];
                for (var key in user) {
                    let value = user[key];
                    userList.push({
                        id: value['id'],
                        name: value['name'],
                    });
                }
                this.setState({
                    user: userList
                })
            }).catch(function (error) {
                Toast.error(error);
            })
        });
    }
    dialogHandleFalse = () => {
        this.setState({
            dialogOpenSearchUser: false
        });
    }
    //登録
    handleSubmit = () => {
        let descriptor = {
            messageContent: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.message) },
                {
                    max: 64,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.message)
                },
            ],
            alertStatus: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.notice_set) },
            ],
            alertTimeStr: [
                {
                    message: this.state.dictWord.msg_error_not_enter_before_date,
                    validator(rule, value, callback, source, options) {
                        if (value !== '' && new Date(value) <= new Date()) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                }
            ]
        }
        const validator = new schema(descriptor);
        let resourceData = {};
        const formData = this.state.formData;
        for (let index in formData) {
            let item = formData[index];
            let value = item.value;
            if (value === null) {
                value = '';
            }
            resourceData[index] = value;
        }
        validator.validate(resourceData, {
            firstFields: true
        }, (errors, fields) => {
            let formData = this.state.formData;
            let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
            let emojierr = [];
            for (let index in formData) {
                formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false })
                let value = formData[index].value;
                if (value && typeof value !== 'object' && value.length > 0) {
                    if (value.search(emojiReg) >= 0) {
                        emojierr.push({ 'message': this.state.dictWord.msg_error_value_invalid, 'field': index });
                    }
                }
            }
            if (errors || emojierr.length > 0) {
                if (errors) {
                    errors.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                if (emojierr.length > 0) {
                    emojierr.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                this.setState({
                    formData: formData
                });
            } else {
                this.setState({
                    dialogOpen: true,
                    formData: formData
                });
            }
        })
    }
    dialogHandleOK = (event) => {
        const confirmData = this.state.formData;
        let alertTime = confirmData['alertTimeStr']['value']
        if (!alertTime) {
            alertTime = ''
        } else {
            alertTime = dateFormat(new Date(alertTime), 'yyyy/MM/dd hh:mm')
        }
        this.setState({
            okLoading: true,
        });
        if (this.props.match.params.messageId !== undefined) {
            let messageId = this.props.match.params.messageId;
            pushUpdate({
                messageId: messageId,
                'messageContent': confirmData['messageContent']['value'],
                'alertStatus': confirmData['alertStatus']['value'],
                'alertTimeStr': alertTime,
                'docMstDepartment': confirmData['DepartmentTags']['value'],
                'docTblUser': confirmData['UserTags']['value']
            }).then(res => {
                this.props.history.push('/admin/notify/pushnotify');
            }).catch(function (error) {
                Toast.error(error);
            })
        } else {
            pushLogin({
                'messageContent': confirmData['messageContent']['value'],
                'alertStatus': confirmData['alertStatus']['value'],
                'alertTimeStr': alertTime,
                'docMstDepartment': confirmData['DepartmentTags']['value'],
                'docTblUser': confirmData['UserTags']['value']
            }).then(res => {
                this.props.history.push('/admin/notify/pushnotify');
            }).catch(function (error) {
                Toast.error(error);
            })
        }

    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false,
        });
    }
    //Cleaning time input box
    clearTime = () => {
        let formData = this.state.formData;
        formData['alertTimeStr'] = Object.assign(this.state['formData']['alertTimeStr'], { value: null });
        this.setState({
            formData: formData
        });
    }
    render() {
        const { classes } = this.props;
        const { dictWord, formData } = this.state;
        return (
            <div className="mainDom" style={{ minWidth: '700px' }}>
                <div className={classes.appBarSpacer} />
                <Typography variant="h6" gutterBottom>
                    {dictWord.push_base_information}
                </Typography>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="messageContent">
                            {dictWord.message}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.messageContent.error} fullWidth>
                            <InputBase
                                id="messageContent"
                                value={this.state.formData.messageContent.value}
                                fullWidth
                                rows="4"
                                multiline
                                onChange={this.handleChange('messageContent')}
                                onKeyUp={this.checkLength('64')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.messageContent.error}
                            />
                            {this.state.formData.messageContent.errorMsg.length > 0 ? <FormHelperText id="messageContent-error-text">{this.state.formData.messageContent.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Typography variant="h6" gutterBottom style={{display:'flex',alignItems:'center'}}>
                    {dictWord.push_notice_information}&emsp;
                    <span style={{ verticalAlign: 'sub', fontSize: '10px' }}>{dictWord.all_user_notice}</span>
                </Typography>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="alertStatus">
                            {dictWord.notice_set}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={this.state.formData.alertStatus.error} fullWidth>
                            <Select
                                value={formData.alertStatus.value}
                                onChange={this.handleChange('alertStatus')}
                                id="alertStatus"
                                name="alertStatus"
                                input={<BootstrapInput />}
                                style={{ width: formData.alertStatus.width }}
                                error={this.state.formData.alertStatus.error}
                            >
                                <MenuItem value="" />
                                {this.state.alertStatus.map((item, index) => {
                                    return <MenuItem key={index} value={index}>{dictWord[item]}</MenuItem>
                                })}
                            </Select>
                            {this.state.formData.alertStatus.error ? <FormHelperText id="alertStatus-error-text">{this.state.formData.alertStatus.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="departmentSpecified">
                            {dictWord.department_specified}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.DepartmentTags.error} fullWidth>
                            <div className="tag-list">
                                {formData.DepartmentTags.value.map((column, j) => {
                                    return <span key={j} className="tags">
                                        {column.departmentName}
                                        <Close className="delBut" fontSize="inherit" color="action" onClick={this.handleDelTags(j)} />
                                    </span>
                                })}
                            </div>
                            {this.state.formData.DepartmentTags.error ? <FormHelperText id="DepartmentTags-error-text">{this.state.formData.DepartmentTags.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" onClick={this.handleSearch} className={classes.margin} style={{ backgroundColor: '#1769aa', color: '#fff' }}>
                            {dictWord.department_search}
                        </Button>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userAppoint">
                            {dictWord.user_appoint}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.UserTags.error} fullWidth>
                            <div className="tag-list">
                                {formData.UserTags.value.map((column, j) => {
                                    return <span key={j} className="tags">
                                        {column.name}
                                        <Close className="delBut" fontSize="inherit" color="action" onClick={this.handleDelUserTags(j)} />
                                    </span>
                                })}
                            </div>
                            {this.state.formData.UserTags.error ? <FormHelperText id="UserTags-error-text">{this.state.formData.UserTags.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" onClick={this.handleSearchUser} className={classes.margin} style={{ backgroundColor: '#1769aa', color: '#fff' }}>
                            {dictWord.user_search}
                        </Button>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="alertTimeStr">
                            {dictWord.notice_reservation}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={this.state.formData.alertTimeStr.error} fullWidth>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                <div className="picker">
                                    <DateTimePicker
                                        ampm={false}
                                        format="yyyy/MM/dd HH:mm"
                                        value={this.state.formData.alertTimeStr.value}
                                        onChange={this.handleChange('alertTimeStr')}
                                    />
                                    <Clear
                                        color="disabled"
                                        style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                        onClick={this.clearTime}
                                    />
                                </div>
                            </MuiPickersUtilsProvider>
                            {this.state.formData.alertTimeStr.error ? <FormHelperText id="alertTimeStr-error-text">{this.state.formData.alertTimeStr.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Typography variant="h5" gutterBottom>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.buttonlogin}>
                            {dictWord.registration}
                        </Button>
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                        <Link to="/admin/notify/pushnotify" className={classes.link}>
                            <Button variant="contained" color="primary" className={classes.buttoncancel}>
                                {dictWord.cancel}
                            </Button>
                        </Link>
                    </Typography>
                </Grid>
                <Dialog
                    open={this.state.dialogOpenSearch}
                    option={{
                        close: {
                            text: this.state.dictWord['close'],
                        },
                        maxWidth: false
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['department_search']}</DialogTitle>}
                    content={
                        <div>
                            <div className={classes.margin}>
                                <div className={classes.bootstrapFormLabel}>
                                    <InputLabel shrink htmlFor="departmentName">
                                        {dictWord.department_designation}
                                    </InputLabel>
                                </div>
                                <div>
                                    <InputBase
                                        style={{minWidth:'265px'}}
                                        id="name"
                                        value={this.state.departmentName}
                                        fullWidth
                                        inputProps={{
                      autoComplete:"off"
                    }}
                                        onChange={this.inputHandleSearch.bind(this)}
                                        onFocus={this.inputHandleSearch.bind(this)}
                                        classes={{
                                            root: classes.bootstrapRoot,
                                            input: classes.bootstrapInput,
                                        }}
                                    />
                                    {this.state.show ? <Paper className={classes.paper}>
                                        <MenuList>
                                            {this.state.department.map((column, j) => {
                                                return <MenuItem key={j} style={{minWidth:'230px'}} onClick={this.handleSearchValue(column.departmentName, column.id)}>{column.departmentName}</MenuItem>
                                            })}
                                        </MenuList>
                                    </Paper> : null}
                                </div>
                            </div>
                        </div>
                    }
                    handleClose={this.dialogHandleOff}
                />
                <Dialog
                    open={this.state.dialogOpenSearchUser}
                    option={{
                        close: {
                            text: this.state.dictWord['close'],
                        },
                        maxWidth: false
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['user_search']}</DialogTitle>}
                    content={
                        <div>
                            <div className={classes.margin}>
                                <div className={classes.bootstrapFormLabel}>
                                    <InputLabel shrink htmlFor="name">
                                        {dictWord.user_name}
                                    </InputLabel>
                                </div>
                                <div>
                                    <InputBase
                                        style={{minWidth:'265px'}}
                                        id="name"
                                        value={this.state.name}
                                        fullWidth
                                        inputProps={{
                      autoComplete:"off"
                    }}
                                        onChange={this.inputHandleSearchUser.bind(this)}
                                        onFocus={this.inputHandleSearchUser.bind(this)}
                                        classes={{
                                            root: classes.bootstrapRoot,
                                            input: classes.bootstrapInput,
                                        }}
                                    />
                                    {this.state.show ? <Paper className={classes.paper}>
                                        <MenuList>
                                            {this.state.user.map((column, j) => {
                                                return <MenuItem key={j} style={{minWidth:'230px'}} onClick={this.handleSearchUserValue(column.name, column.id)}>{column.name}</MenuItem>
                                            })}
                                        </MenuList>
                                    </Paper> : null}
                                </div>
                            </div>
                        </div>
                    }
                    handleClose={this.dialogHandleFalse}
                />
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_warning_push_notice_information']}</p>
                    }
                    okLoading={this.state.okLoading}
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

PushNotify_Edit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PushNotify_Edit);